import React, { useState, useEffect } from 'react'
import NavBar from '../../containers/NavBar';
import { ReactComponent as CloseIcon } from '../../img/ic_cerrar.svg';
import { editRoom, getRoom } from '../../actions/userActions'
import { Translate } from '../../language';
import { ReactComponent as BackIcon } from '../../img/flecha-hacia-atras.svg';
import { seeListChatCategories } from '../../admin/actions/categoriesActions'
import { connect } from 'react-redux'
import { UseComponentVisible2 } from '../../containers/UseComponentVisible2'
import inMemoryJWT from '../../auth/inMemoryJwt';
import Button from '../../utils/components/Button/Button';
import localStorage from '../../utils/hooks/useLocalStorage';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const EditRoom = ({ match, history, seeListChatCategories, isLoadingListChatCategories, listChatCategories, getRoom, editRoom, roomInfo, location }) => {
    var idRoom = match.params.idRoom
    const [error, setError] = useState({})
    const [categorieSearch, setCategorieSearch] = useState('')
    const [nameRoom, setNameRoom] = useState('')
    const [categorie, setCategorie] = useState(null)
    const [rules, setRules] = useState('')
    const [description, setDescription] = useState('')
    const [privacy, setPrivacy] = useState('')
    const [amountOfParticipants, setAmountOfParticipants] = useState('')
    const [isValidate, setValidate] = useState(true)
    const [dataFile, setDataFile] = useState(null)
    const [categorieID, setCategorieID] = useState('')
    const [profilePicture, setProfilePicture] = useState(null)
    const [isAdmin, setIsAdmin] = useState(false)




    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getRoom(idRoom)
        })

    }, [])

    useEffect(() => {
        setNameRoom(roomInfo.name)
        setDescription(roomInfo.description)
        setAmountOfParticipants(roomInfo.numberOfMembers)
        setPrivacy(roomInfo.privacity)
        setRules(roomInfo.rules)
        setCategorieID(roomInfo.chatCategoriesID && roomInfo.chatCategoriesID._id)
        setCategorie(roomInfo.chatCategoriesID && roomInfo.chatCategoriesID.name)
        setProfilePicture(roomInfo.profilePicture && roomInfo.profilePicture.url && roomInfo.profilePicture.url.origin)
        setIsAdmin(roomInfo.adminID === localStorage().getItem("idProfile"))
    }, [roomInfo])

    useEffect(() => {
        if (nameRoom === '' || description === '' || rules === '' || privacy === '' || amountOfParticipants === '') {
            setValidate(false)
        }

        if (nameRoom !== '' && description !== '' && rules !== '' && privacy !== '' && amountOfParticipants !== '') {
            setValidate(true)
        }
    }, [dataFile])


    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListChatCategories()
        })

    }, [])
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Requerido'),
        rules: Yup.string().required('Requerido'),

        privacy: Yup.number().required('Requerido'),
        amountOfParticipants: Yup.number().required('Requerido'),
        categorieID: Yup.string().required('Requerido')

    });
    const formik = useFormik({
         validationSchema,
        enableReinitialize:true,
      
        initialValues: {
            name: roomInfo.name,
            rules: roomInfo.rules,
            privacy: roomInfo.privacity,
            amountOfParticipants: roomInfo.numberOfMembers,
            categorieID: roomInfo.chatCategoriesID._id
        },
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append('chatRoomID', idRoom)
            formData.append('files', values.files)
            console.log()
            formData.append('name', values.name)

            formData.append('chatCategoriesID', values.categorieID)
            formData.append('privacity', values.privacy)
            formData.append('description', values.description)
            formData.append('rules', values.rules)
            formData.append('numberOfMembers', values.amountOfParticipants)

            editRoom(formData, history)
        }
    })

    const {
        ref2,
        isComponentVisible2,
        setIsComponentVisible2
    } = UseComponentVisible2(false);

    const isEmpty = (e) => {
        console.log()
        if (nameRoom === '' || description === '' || rules === '' || privacy === '' || amountOfParticipants === '') {
            setValidate(false)
        }

        if (nameRoom !== '' && description !== '' && rules !== '' && privacy !== '' && amountOfParticipants !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        console.log()
        if (value.length === 0) {

            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));




        }

    }

    const auto_height = (e) => {
        var EmojiPicker = document.getElementsByName("picker-emoji-new-post")
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }


    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }




    const onFileChange = (event) => {
        var filesTarget = event.target.files[0]
        filesTarget.url = URL.createObjectURL(event.target.files[0])
        setDataFile(filesTarget)
        setProfilePicture(filesTarget.url)
        formik.setFieldValue("files", filesTarget)

    }

    const saveRoom = () => {
        const formData = new FormData();
        if (isAdmin) {
            formData.append('files', dataFile)
            formData.append('name', nameRoom.trim())
            formData.append('adminID', localStorage().getItem('idProfile'))
            formData.append('chatCategoriesID', categorieID)
            formData.append('privacity', privacy)
            formData.append('description', description)

            formData.append('chatRoomID', idRoom)
            formData.append('numberOfMembers', amountOfParticipants)
        }
        formData.append('rules', rules)



        editRoom(formData, history)

    }


    const handleSelectPrivacy = (e) => {
        var { value } = e.target;
        setPrivacy(value)
        if (nameRoom !== '' && description !== '' && rules !== '' && privacy !== '' && amountOfParticipants !== '') {
            setValidate(true)
        }
    }
    return (
        <div className="relative">
            <div className="container-room-create">
                <div className="community-create-title">
                    Edita tu sala
                </div>
                {
                    isAdmin && (
                        <label className="picture-room-create ">
                            <input type="file" onChange={(event) => {
                                if (event.target.files[0] && event.target.files[0].type.includes('image')) {
                                    onFileChange(event)
                                }
                            }} accept="image/*" />
                            {profilePicture && <img className="img-create-room " src={profilePicture}></img>}
                        </label>
                    )
                }



                <div className="container-room-create_form">
                    {
                        isAdmin && (
                            <div style={{
                                gridArea: "a"
                            }}>
                                <input
                                    className='input-room-create mb-2'
                                    name="name"
                                    value={formik.values.name}
                                    type="text"
                                    placeholder='Nombre de la sala'
                                    onChange={formik.handleChange}

                                />
                                <div className="text-error">{formik.errors.name}</div>
                            </div>
                        )
                    }
                    {
                        isAdmin && (
                            <div style={{
                                gridArea: "b"
                            }}>
                                <div className="parent-width relative" ref={ref2}>
                                    <div
                                        className="parent-width"
                                        onClick={() =>
                                            setIsComponentVisible2(true)
                                        }
                                    >
                                        <div name="categorie" className='input-room-create'>
                                            {categorie ?
                                                <>
                                                    {categorie}
                                                    <div onClick={(e) => {
                                                        e.stopPropagation();
                                                        setCategorie(null)
                                                    }} className="close-select-input">
                                                        <CloseIcon className="cls-1" height="10" width="10" />
                                                    </div>
                                                </>
                                                :
                                                'Categoria'
                                            }

                                        </div>
                                        <div className="text-error">{error.categorie}</div>
                                    </div>
                                    {isComponentVisible2 &&
                                        <div className='scroll-menu modal-search-bar-economic-activities'>
                                            <input
                                                autoComplete="off"
                                                className='input-room-create select-search-input'
                                                name="categorieSearch"
                                                type="text"
                                                value={categorieSearch}
                                                placeholder='Buscar'
                                                onChange={(e) => {
                                                    setCategorieSearch(e.target.value)
                                                }}
                                            />
                                            <div className="modal-results-search-bar">
                                                <div>
                                                    {!isLoadingListChatCategories &&
                                                        <>
                                                            {listChatCategories.filter(category => category.name.toUpperCase().includes(categorieSearch.toUpperCase())).map(category =>
                                                                <div onClick={() => {
                                                                    setCategorie(category.name)
                                                                    setCategorieID(category._id)
                                                                    formik.setFieldValue("categorieID", category._id)
                                                                    setIsComponentVisible2(false)
                                                                    if (nameRoom !== '' && description !== '' && rules !== '' && privacy !== '' && amountOfParticipants !== '') {
                                                                        setValidate(true)
                                                                    }
                                                                }} className="mb-2">
                                                                    {category.name}
                                                                </div>
                                                            )}
                                                            {listChatCategories.filter(category => category.name.toUpperCase().includes(categorieSearch.toUpperCase())).length === 0 &&
                                                                <div className="">{'No hay resultados'}</div>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    }

                    <div style={{
                        gridArea: "c"
                    }}>
                        <textarea
                            className='scroll-menu input-rules-room'
                            rows="4"
                            value={formik.values.rules}
                            onChange={formik.handleChange}
                            name="rules"
                            type="text"
                            placeholder='Normas de la sala' />
                        <div className="text-error">{formik.errors.rules}</div>
                    </div>
                    {
                        isAdmin && (
                            <div style={{
                                gridArea: "d"
                            }}>
                                <select value={formik.values.privacy} className='input-room-create input-room-select mb-2' name="privacy" id="privacy" onChange={formik.handleChange}>
                                    <option value="" selected disabled hidden>Privacidad</option>
                                    <option value='0'>Publico</option>
                                    <option value='1'>Privado</option>
                                </select>
                                <div className="text-error">{formik.errors.privacy}</div>
                            </div>
                        )
                    }
                    {
                        isAdmin && (
                            <div style={{
                                gridArea: "e"
                            }}>
                                <input
                                    className='input-room-create mb-2'
                                    name="amountOfParticipants"
                                    value={formik.values.amountOfParticipants}
                                    min='1'
                                    type="number"
                                    placeholder='Numero de participantes'
                                    onChange={formik.handleChange}


                                />
                                <div className="text-error">{formik.errors.amountOfParticipants}</div>
                            </div>
                        )
                    }

                    {/*  <div className="left-container-professional-create relative">

                        <input
                            className='input-room-create mb-2'
                            name="description"
                            style={{
                                gridArea: "a"
                            }}
                            value={description}
                            type="text"
                            placeholder='Descripción'
                            onChange={e => setDescription(e.target.value.trimStart())}
                            onBlur={e => isEmpty(e)}
                            onFocus={e => isFocused(e)}
                            onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                            onMouseOut={e => setDescription(e.target.value.trim())}
                        />
                        <div className="text-error">{error.description}</div>

                        <select value={privacy} className='input-room-create input-room-select mb-2' name="privacy" id="privacy" onChange={(e) => { handleSelectPrivacy(e) }}>
                            <option value="" selected disabled hidden>Privacidad</option>
                            <option value='0'>Publico</option>
                            <option value='1'>Privado</option>
                        </select>


                        <div className="text-error">{error.privacy}</div>
                        <input
                            className='input-room-create mb-2   '
                            style={{
                                gridArea: "a"
                            }}
                            name="amountOfParticipants"
                            value={amountOfParticipants}
                            min='1'
                            type="number"
                            placeholder='Numero de participantes'
                            onChange={e => setAmountOfParticipants(e.target.value.trimStart())}
                            onBlur={e => isEmpty(e)}
                            onFocus={e => isFocused(e)}
                            onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                            onMouseOut={e => setAmountOfParticipants(e.target.value.trim())}

                        />
                        <div className="text-error">{error.amountOfParticipants}</div>





                    </div>
                    <div className="right-container-professional-create">
                        <textarea
                            className='scroll-menu input-rules-room'
                            style={{
                                gridArea: "a"
                            }}
                            rows="4"
                            value={rules}
                            onChange={e => setRules(e.target.value.trimStart())}
                            onBlur={e => isEmpty(e)}
                            onFocus={e => isFocused(e)}
                            onInput={e => auto_height(e)}
                            onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                            onMouseOut={e => setRules(e.target.value.trim())}
                            name="rules"
                            type="text"
                            placeholder='Normas de la sala' />


                        <div className="parent-width relative" ref={ref2}>
                            <div
                                className="parent-width"
                                onClick={() =>
                                    setIsComponentVisible2(true)
                                }
                            >
                                <div name="categorie" className='input-room-create'>
                                    {categorie ?
                                        <>
                                            {categorie}
                                            <div onClick={(e) => {
                                                e.stopPropagation();
                                                setCategorie(null)
                                            }} className="close-select-input">
                                                <CloseIcon className="cls-1" height="10" width="10" />
                                            </div>
                                        </>
                                        :
                                        'Categoria'
                                    }

                                </div>
                                <div className="text-error">{error.categorie}</div>
                            </div>
                            {isComponentVisible2 &&
                                <div className='scroll-menu modal-search-bar-economic-activities'>
                                    <input
                                        autoComplete="off"
                                        className='input-room-create select-search-input'
                                        name="categorieSearch"
                                        type="text"
                                        value={categorieSearch}
                                        placeholder='Buscar'
                                        onChange={(e) => {
                                            setCategorieSearch(e.target.value)
                                        }}
                                    />
                                    <div className="modal-results-search-bar">
                                        <div>
                                            {!isLoadingListChatCategories &&
                                                <>
                                                    {listChatCategories.filter(category => category.name.toUpperCase().includes(categorieSearch.toUpperCase())).map(category =>
                                                        <div onClick={() => {
                                                            setCategorie(category.name)
                                                            setCategorieID(category._id)
                                                            setIsComponentVisible2(false)
                                                            if (nameRoom !== '' && description !== '' && rules !== '' && privacy !== '' && amountOfParticipants !== '') {
                                                                setValidate(true)
                                                            }
                                                        }} className="mb-2">
                                                            {category.name}
                                                        </div>
                                                    )}
                                                    {listChatCategories.filter(category => category.name.toUpperCase().includes(categorieSearch.toUpperCase())).length ===0 &&
                                                        <div className="">{'No hay resultados'}</div>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div> */}
                </div>

                <div className="btns-room">
                    <Button
                        theme='white'
                        text='Guardar'
                        type='submit'
                        disabled={!formik.isValid}
                     
                        onClick={formik.handleSubmit} 
                    />
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        isLoadingListChatCategories: state.socialCategoriesAdmin.isLoadingListChatCategories,
        listChatCategories: state.socialCategoriesAdmin.listChatCategories,
        roomInfo: state.userInfo.roomInfo
    }
}


export default connect(mapStateToProps, { seeListChatCategories, getRoom, editRoom })(EditRoom)
